import { memo } from "react";

import { Link } from "@components/Link";
import { Text } from "@components/Text";
import { type TTailwindString, tw } from "classnames";

interface Props {
  breadcrumbsLabel: string;
  items: { title: string; url: string }[];
}

const styles = {
  list: tw("m-0", "flex", "list-none", "p-0", "text-primary"),
  item: tw(
    "flex",
    "items-center",
    "leading-snug",
    "[&:not(:last-child):after]:content-['/']" as TTailwindString,
    "after:pl-2" as TTailwindString,
    "after:pr-1.5" as TTailwindString,
    "after:text-xs" as TTailwindString,
    "after:font-calibre" as TTailwindString
  ),
};

const BreadcrumbsViewBase = ({ breadcrumbsLabel, items }: Props) => {
  return (
    <nav
      aria-label={breadcrumbsLabel}
      data-mtr-section="breadcrumbs"
      data-tbsp-component="breadcrumbs"
    >
      <ol className={styles.list}>
        {items.map((item, index) => (
          <li
            className={styles.item}
            data-mtr-level={index + 1}
            data-mtr-level-header={item.title}
            key={`${item.title}-${index}`}
          >
            {items.length === index + 1 &&
            window.location.pathname === item.url ? (
              <Text as="caption">{item.title}</Text>
            ) : (
              <Link
                mtrAs="clickBreadcrumbLink"
                size="sm"
                to={item.url}
                type="secondary"
              >
                {item.title}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export const BreadcrumbsView = memo(BreadcrumbsViewBase);
